<template>
<FoldSection v-if="video" expand title="Preview the experience">
  <client-only placeholder="Loading...">
    <div class="event-detail-hero">
      <div class="player">
        <div class="control-button">
          <button @click="switchMute" class="mute-button">
            <img v-if="muted" :src="MuteIcon" class="lazyload" />
            <img v-else :src="UnmuteIcon" class="lazyload" />
          </button>
          <button class="video-close" @click="closeVideo">
            <img :data-src="VideoClose" class="lazyload" />
          </button>
        </div>
        <div class="pl-wrap">
          <vueVimeoPlayer
            v-if="this.displayVimeoVideo"
            ref="player"
            :video-id="video"
            :options="videoOption"
            class="vimeo-player vimeo-player-1"
            width="100%"
            player-height="500"
          />
        </div>
      </div>
      <div class="extra-expand">
        <div
          class="play-button"
          :href="video"
          @click="playVideo"
        >
          <div class="watch">Watch</div>
          <img
            class="hero-play playpause start hero-open"
            src="~/assets/svg/hero-play.svg"
            @click="injectVimeo()"
            width="120"
            height="120"
          />
          <div class="video">Video</div>
        </div>
        <figure
          :style="'background-image: url(' + getImageURL(tourBanner) + ')'"
        ></figure>
      </div>
    </div>
  </client-only>
</FoldSection>
</template>

<script>
import FoldSection from "@/components/containers/FoldSection"
import VideoClose from '~/static/close-video.svg'
import imageOptimo from '~/mixins/imageOptimoMixin.js'
import {vueVimeoPlayer} from 'vue-vimeo-player'
import MuteIcon from '~/static/mute.svg'
import UnmuteIcon from '~/static/unmute.svg'

export default {
  name: 'TourDetailHero',
  mixins: [imageOptimo],
  components: {
    vueVimeoPlayer,
    FoldSection
  },
  props: {
    video: String,
    tourBanner: String
  },
  data() {
    return {
      VideoClose: VideoClose,
      displayVimeoVideo: false,
      muted: false,
      MuteIcon: MuteIcon,
      UnmuteIcon: UnmuteIcon,
      videoOption: {
        pip: true
      }
    }
  },
  methods: {
    play() {
      this.$refs.player.play()
    },
    pause() {
      this.$refs.player.pause()
    },
    mute() {
      this.muted = true
      this.$refs.player.mute()
    },
    unmute() {
      this.muted = false
      this.$refs.player.unmute()
    },
    switchMute() {
      this.muted ? this.unmute() : this.mute()
    },
    getImageURL(url) {
      return this.setAutoWidth(url)
    },
    injectVimeo() {
      this.displayVimeoVideo = true
      this.showVideo()
    },
    showVideo() {
      var h = $('.pl-wrap').height()
      var pl = $('.player')
      pl.css('top', h / 2)
    },
    playVideo() {
      const pl = $('.player')
      $('.hero-open').hide()
      $('.extra-expand').hide()
      $('.video-close').show()
      pl.addClass('active')
      this.play()
    },
    closeVideo() {
      const pl = $('.player')
      pl.removeClass('active')
      this.pause()
      $('.hero-open').show()
      $('.video-close').hide()
      $('.extra-expand').show()
    },
  }
}
</script>

<style scoped>
.control-button {
  position: absolute;
  width: 100%;
  padding: 8px;
  top: 0;
  z-index: 10;
  display: flex;
  justify-content: space-between;
}

.mute-button {
  cursor: pointer;
  width: 48px;
  height: 48px;
  background-color: transparent;
  color: white;
  margin-top: 8px;
  margin-left: 8px;
}
</style>